import ExpandableButton from './ExpandableButton'
import './OrganizationTreeActions.css'

export default function OrganizationTreeActions({ rows, expandedIds, onExpandedChange, searchActive = false }) {
  const groupIds = rows
    .filter((row) => row.type === 'reseller' && row.hasChildren)
    .map((row) => row.item.user_id)
  const allExpanded = groupIds.length > 0 && groupIds.every((id) => expandedIds[id])
  const anyExpanded = groupIds.some((id) => expandedIds[id])
  const setAllExpanded = (expanded) => onExpandedChange(Object.fromEntries(groupIds.map((id) => [id, expanded])))

  return (
    <div className="org-tree-actions">
      <ExpandableButton
        className="org-tree-action"
        expanded={allExpanded}
        onClick={() => setAllExpanded(true)}
        disabled={searchActive || !groupIds.length || allExpanded}
      >
        Alle aufklappen
      </ExpandableButton>
      <span className="org-tree-action-separator" aria-hidden="true">·</span>
      <ExpandableButton
        className="org-tree-action"
        expanded={anyExpanded}
        onClick={() => setAllExpanded(false)}
        disabled={searchActive || !anyExpanded}
      >
        Alle zuklappen
      </ExpandableButton>
    </div>
  )
}
